<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data () {
    return {
      url: ""
    };
  },
  mounted () {
    // 禁用了空格的输入
    // document.onkeydown = function (event) {
    //   if (event.keyCode == 32) {
    //     return false;
    //   }
    // };
    // this.url = encodeURIComponent("https://gyh-cssc.oss-cn-hangzhou.aliyuncs.com/pre/248AE7549DAB4567B46ADBDDD9BF98B9.pptx")
    this.$nextTick(() => {
      // initialization of slick carousel
      $(".js-slick-carousel").each(function () {
        var slickCarousel = $.HSCore.components.HSSlickCarousel.init($(this));
      });
      // initialization of form validation
      $(".js-validate").each(function () {
        var validation = $.HSCore.components.HSValidation.init($(this));
      });
      window.addEventListener("keydown", function (event) {
        let e = event || window.event || arguments.callee.caller.arguments[0];
        // console.log('e---',e)
        if (e && e.keyCode == 13) {
          return e.srcElement.tagName == "TEXTAREA";
        }
      });
    });
  }
};
</script>

<style lang="scss">
@import "assets/reset_element.scss";
#app {
  font-family: AlibabaPuHuiTi-2-55-Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html,body{
  font-family: AlibabaPuHuiTi-2-55-Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.require-tip {
  color: #f00;
}

/*頁面内编辑新增弹窗样式*/
.modals-show {
  display: block;
  background: rgba(0, 0, 0, 0.3);
}
.modal-body {
  max-height: 410px;
  overflow: auto;
}

.static-span {
  min-width: 55px;
  padding: 5px 10px;
  font-size: 14px !important;
}

.color-label {
  width: 15px;
  height: 15px;
  border-radius: 100%;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 5px;
}

.normal-row {
  background: #fff;
  border: 1px solid #886ab5;
}

.warning-row {
  background-color: #ffc241; //待审核的行背景色
  opacity: 0.65;
}

.delete-row {
  background-color: #ccc; //已删除的行背景色
}

.nocheck-row {
  background-color: #e3e6d8;
}

.warning-row2 {
  background-color: #ccc; //待审核灰色
}

.font-warning {
  color: #ccc;
}

.pass-row {
  background-color: #1dc9b7; //审核通过绿色
}

.font-pass {
  color: #1dc9b7;
}

.failed-row {
  background-color: #fd3995; //审核不通过
}

.font-failed {
  color: #fd3995;
}

.el-image {
  width: 100%;
  height: 0px;
  padding-bottom: 100%;
  overflow: hidden;
  position: relative;
  img {
    position: absolute;
  }
  .el-image__error {
    position: absolute;
  }
}

.el-loading-mask,
.el-message--error,
.el-message--warning,
.el-message--success {
  z-index: 3000 !important;
}

.el-loading-spinner i {
  font-size: 3rem !important;
}
.el-loading-spinner .el-loading-text {
  font-size: 1rem !important;
}

.one-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.two-ellipsis {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.three-ellipsis {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.drop-con {
  .el-dropdown {
    min-width: 45px;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #886ab5;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
}

.dt-buttons .el-dialog__body {
  max-height: 500px;
  overflow: auto;
}

.dt-buttons .el-dialog {
  width: 50% !important;
}

.edit—model .el-dialog {
  width: 45% !important;
}

.no-public-txt {
  color: #868e96;
  font-size: 10px;
}

audio::-webkit-media-controls {
  overflow: hidden !important;
}
audio::-webkit-media-controls-enclosure {
  width: calc(100% + 36px);
  margin-left: auto;
}

audio {
  border-radius: 50px;
}

video::-webkit-media-controls {
  overflow: hidden !important;
}
video::-webkit-media-controls-enclosure {
  width: calc(100% + 36px);
  margin-left: auto;
}

video {
  // border-radius: 50px;
}

.bold-txt {
  font-weight: bold;
}
.el-cascader .el-input__inner {
  width: 100%;
  height: 32px;
  padding: 13px 18px;
  font-size: 14px;
  color: #101010;
  line-height: 20px;
  background: #fff;
  border-radius: 4px;
  border:1px solid #DCDFE6;
}
.el-input__inner::placeholder {
  color: #868e96;
}
.el-carousel__indicator--horizontal {
  padding: 0 0 26px 0;
}

.el-carousel__indicators--horizontal {
  padding: 0;
  .el-carousel__indicator--horizontal button {
    width: 24px;
    height: 24px;
    border: 4px solid #fff;
    border-radius: 50%;
    background: rgba(255, 0, 0, 0);
    margin: 0 32px;
    opacity: 1;
  }

  .el-carousel__indicator--horizontal.is-active button {
    background: #fff;
  }
}
.el-carousel__item img {
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.p-img-box {
  .swiper-pagination {
    position: unset;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .swiper-pagination-bullet {
      width: 16px;
      height: 16px;
      font-size: 14px;
      line-height: 16px;
      background: #c4c4c4;
      color: #c4c4c4;
      border-radius: 50%;
      margin: 0 5px;
    }
    .swiper-pagination-bullet-active {
      background: #0088ff !important;
      width: 24px;
      height: 24px;
      line-height: 24px;
      color: #0088ff !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue